<template>
  <div>
    <div id="archiveOuter" :class="{entered}">
      <div v-if="all" id="archive" :class="{done: done}" :key="$route.params.filter">
        <Group @last="last" @closeSelected="closeSelected" @setSelectedOpen="setSelectedOpen" v-for="(card, index) in cards" :key="index" :card="card" :index="index" :total="total" :loadThis="load" :view="view"/>
      </div>
    </div>

    <transition name="l-fade" mode="out-in" appear @after-enter="afterEnter">
      <router-view :key="$route.params.slug"/>
    </transition>
  </div>
</template>

<script>
import Group from '@/components/Group.vue'

export default {
  data () {
    return {
      card: false,
      entered: false,
      laureats: false,
      trigClose: false,
      scrollP: 0,
      load: 0,
      done: false
    }
  },

  components: {
    Group
  },

  methods: {
    last () {
      this.done = true
      window.scrollTo(0, 99999999)
    },

    setSelectedOpen () {
      this.scrollP = window.scrollY
    },

    closeSelected () {
      window.scrollTo(0, this.scrollP)
    },

    afterEnter () {
      this.entered = true
    }
  },

  computed: {
    total () {
      return this.cards.length
    },

    all () {
      return this.$store.getters.all
    },

    view () {
      let view
      if (this.$route.params.filter === 'annees') view = 'year'
      if (this.$route.params.filter === 'prix') view = 'prix'
      if (this.$route.params.filter === 'domaine') view = 'domaine'
      return view
    },

    cards () {
      return this.all.map(item => item[this.view].title).filter((value, index, self) => self.indexOf(value) === index).reverse().sort()
    }
  },

  mounted () {
    this.$store.commit('editState', { state: 'cardActive', data: false })
    this.$store.commit('editState', { state: 'cardOpen', data: false })

    this.$nextTick(() => {
      window.scrollTo(0, 99999999)
    })
  },

  watch: {
    '$route' (to, from) {
      if (to.name === 'laureats-laureat') {
        this.$nextTick(() => {
          window.scrollTo(0, 0)
        })
      } else if (from.name === 'laureats-laureat' && to.name === 'laureats') {
        this.entered = false
      } else {
        this.$store.commit('editState', { state: 'cardActive', data: false })
        this.$store.commit('editState', { state: 'cardOpen', data: false })

        this.$nextTick(() => {
          window.scrollTo(0, 99999999)
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';

.appear-class {
  opacity: 0;
}

.appear-active-class {
  transition: opacity 2s ease 2s;
}

.l-fade-enter, .l-fade-leave-to {
  opacity: 0;
}

.l-fade-enter-active, .l-fade-leave-active {
  transition: opacity 0.5s ease 0.1s;
}

#archive {
  opacity: 0;
}

#archive.done {
  opacity: 1;
}
</style>
